export const getThemeColor = {
  gammaplex: '#45b939',
  coagadex: '#004789',
  gammaked: '#37afd0',
  koate: '#152763',
  ryplazim: '#742191',
  alphanine: '#c4112f',
  gamunex: '#00a9a9',
  prolastin: '#0078c1',
  xembify: '#034ea1',
  alyglo: '#45b939',
  kedrab: '#24afe9',
  nuwiq: '#00b597',
  wilate: '#f4943f',
  octagam: '#004996',
  cutaquig: '#227586',
  panzyga: '#5d2c68',
  fibryga: '#af0061',
};

export const getManufacturerLogo = {
  alphanine: '/images/grifols_logo.png',
  alyglo: '/images/gc_logo.png',
  coagadex: '/images/kedrion_logo.png',
  cutaquig: '/images/octapharma_logo.svg',
  fibryga: '/images/octapharma_logo.svg',
  gammaked: '/images/kedrion_logo.png',
  gammaplex: '/images/kedrion_logo.png',
  gamunex: '/images/grifols_logo.png',
  kedrab: '/images/kedrion_logo.png',
  koate: '/images/kedrion_logo.png',
  nuwiq: '/images/octapharma_logo.svg',
  octagam: '/images/octapharma_logo.svg',
  panzyga: '/images/octapharma_logo.svg',
  prolastin: '/images/grifols_logo.png',
  ryplazim: '/images/kedrion_logo.png',
  wilate: '/images/octapharma_logo.svg',
  xembify: '/images/grifols_logo.png',
};

export const getProgramLogo = {
  alphanine: '/images/programs/alphanine_logo.png',
  alyglo: '/images/programs/alyglo_logo.png',
  coagadex: '/images/programs/coagadex_logo.png',
  cutaquig: '/images/programs/cutaquig_logo.png',
  fibryga: '/images/programs/fibryga_logo.png',
  gammaked: '/images/programs/gammaked_logo.png',
  gammaplex: '/images/programs/gammaplex_logo.png',
  gamunex: '/images/programs/gamunex_logo.png',
  kedrab: '/images/programs/kedrab_logo.png',
  koate: '/images/programs/koate_logo.png',
  nuwiq: '/images/programs/nuwiq_logo.png',
  octagam: '/images/programs/octagam_logo.png',
  panzyga: '/images/programs/panzyga_logo.png',
  prolastin: '/images/programs/prolastin_logo.png',
  ryplazim: '/images/programs/ryplazim_logo.png',
  wilate: '/images/programs/wilate_logo.png',
  xembify: '/images/programs/xembify_logo.png',
};
